import { useQuery } from "@tanstack/react-query";
import { IdNameField } from "api/client.generated";
import useApi from "./useApi";

interface UseConnectWiseProductTypesReturn {
  cwProductTypes: IdNameField[] | undefined;
  isCwProductTypesFetching: boolean;
}

const useConnectWiseProductTypes = (): UseConnectWiseProductTypesReturn => {
  const { connectWiseApiProxyClient } = useApi();

  const loadData = async (): Promise<IdNameField[]> => {
    const response = await connectWiseApiProxyClient.getCatalogItemTypes();
    return response.items;
  };

  const { data, isFetching } = useQuery({
    queryKey: ["getCatalogItemTypes"],
    queryFn: loadData,
  });

  return {
    cwProductTypes: data,
    isCwProductTypesFetching: isFetching,
  };
};

export default useConnectWiseProductTypes;
